import React from 'react';
import { useSelector } from 'react-redux';
import { Lang } from '@debbie/common/dist/lang/Lang.js';
import Select from './Select.js';
export const AllLanguagesInput = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Select, { disabled: props.disabled, value: props.language, onChange: (e) => {
            !props.disabled &&
                props.onChange &&
                props.onChange(e.target.value);
        } },
        !props.language && React.createElement("option", { value: "" }, "-"),
        Object.keys(Lang)
            .sort((a, b) => lang.languages[a].localeCompare(lang.languages[b]))
            .map((l) => (React.createElement("option", { key: l, value: l }, lang.languages[l])))));
};
export default AllLanguagesInput;
//# sourceMappingURL=AllLanguagesInput.js.map